import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import styles from './SignUpMessage.module.scss';

const SignUpMessage = () => {
  const { t } = useTranslation('signUp');

  return (
    <div className={styles.signUpMessage}>
      <FontAwesomeIcon icon={faCircleCheck} />
      <p>
        <b>{t('successfulSignUpTitle')}</b>&nbsp;
        {t('successfulSignUpText')}
      </p>
    </div>
  );
};

export default SignUpMessage;
